import {
  DeleteNoticeRequest,
  DeleteNoticeRequestToJSON,
  HTTPBody,
  Notice,
  NoticeFromJSON,
  RegisterNoticeRequest,
  RegisterNoticeRequestToJSON,
  UpdateNoticeRequest,
  UpdateNoticeRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class NoticeApi extends runtime.BaseAPI {
  async getNotices(): Promise<Notice[]> {
    const response = await this.requestGet('/notices')

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(NoticeFromJSON)
    ).value()
  }

  async getNotice(id: string): Promise<Notice> {
    const response = await this.requestGet(`/notices/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      NoticeFromJSON(jsonValue)
    ).value()
  }

  async registerNotice(
    request: RegisterNoticeRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterNoticeRequestToJSON(request)

    const response = await this.requestPost('/notices', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  async updateNotice(
    request: UpdateNoticeRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateNoticeRequestToJSON(request)

    const response = await this.requestPut(
      `/notices/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async deleteNotice(
    request: DeleteNoticeRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteNoticeRequestToJSON(request)

    const response = await this.requestDelete(
      `/notices/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
